import React from 'react'

import { GuestData, Property } from '../../service/cart'

export interface Props {
  onGuestChange: (evt: React.ChangeEvent<HTMLSelectElement>, key: keyof GuestData) => void
  property: Property
  guests: GuestData
}

const GuestSelect: React.FunctionComponent<Props> = (props) => {
  const { onGuestChange, property, guests } = props
  const totalGuests = guests.adults + guests.children;

  const adults: number[] = property.capacity.adults.length > 0
    ? property.capacity.adults 
    : [ ...Array(property.capacity.sleeps) ].map((value, index) => index + 1)

  const children: number[] = property.capacity.children.length > 0
    ? property.capacity.children 
    : [ ...Array(property.capacity.sleeps) ].map((value, index) => index + 1)
    
  const infants: number[] = property.capacity.infants.length > 0
    ? property.capacity.infants 
    : [ ...Array(property.capacity.sleeps) ].map((value, index) => index + 1)

  return <>
    <div>
      <span>Adults:</span>
      <select onChange={evt => onGuestChange(evt, 'adults')} value={guests.adults}>
        {
          adults.filter(val => {
            return (totalGuests - guests.adults) + val <= property.capacity.sleeps ||
              guests.adults >= val
          }).map(val => {
            return <option key={val} value={val}>{val}</option>
          })
        }
      </select>
    </div>
    <div>
      <span>Children:</span>
      <select onChange={evt => onGuestChange(evt, 'children')} value={guests.children}>
        <option value={0}>0</option>
        {
          children.filter(val => {
            return (totalGuests - guests.children) + val <= property.capacity.sleeps ||
              guests.children >= val
          }).map(val => {
            return <option key={val} value={val}>{val}</option>
          })
        }
      </select>
    </div>
    <div>
      <span>Infants:</span>
      <select onChange={evt => onGuestChange(evt, 'infants')} value={guests.infants}>
        <option value={0}>0</option>
        {
          infants.map(val => {
            return <option key={val} value={val}>{val}</option>
          })
        }
      </select>
    </div>
  </>
}

export default GuestSelect

